module.exports = __webpack_public_path__ + "img/album-TheBends.2db3b493.jpg";